import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const StudentEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Student Information</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="firstName" fullWidth />
        <TextInput source="lastName" fullWidth />
        <TextInput source="studentNumber" label="Student Number" fullWidth />
        <TextInput source="dateOfBirth" type="date" fullWidth />
        <TextInput source="grade" fullWidth />
        <TextInput source="school" fullWidth />
        <TextInput source="email" type="email" fullWidth />
        <TextInput source="phone" fullWidth />
        <TextInput source="clientId" fullWidth label="Client ID" />
        <SelectInput
          source="status"
          choices={['Draft', 'Active', 'Inactive'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Parent / Guardian</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="parentGuardian.name" label="Name" fullWidth />
        <TextInput source="parentGuardian.relationship" label="Relationship" fullWidth />
        <TextInput source="parentGuardian.phone" label="Phone" fullWidth />
        <TextInput source="parentGuardian.email" label="Email" type="email" fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
);
